import Placeholder, { PLACEHOLDER_TYPE } from './@legacy/Placeholder'
import { Card } from './ui/Card'

const LoadingCard = () => (
  <Card className="!my-6 rounded-lg !border-none !p-6">
    <Placeholder type={PLACEHOLDER_TYPE.PARAGRAPH} />
  </Card>
)

export default LoadingCard
